import React, {memo} from "react"
import {LoadingOutlined} from "@ant-design/icons"
import {Spin} from "antd"
import s from "./loading.module.scss"

const antIcon = <LoadingOutlined style={{fontSize: 24}} spin/>

type Props = {
    style?: Object
}
export const Loading: React.FC<Props> = memo(({style}) => {
    return (
        <div className={s.spinner} style={style}>
            <Spin indicator={antIcon}/>
        </div>
    )
})
